import { Box, Skeleton, Stack } from '@mui/material';
import PeriodFilter from '@/components/Base/PeriodFilter';
import React, { useEffect, useState } from 'react';
import { groupBy } from 'lodash';
import ScoreInadimplenciaChart from './components/ScoreInadimplenciaChart';
import { useConsolidationScoreInadimplencia } from '@/features/dashboard/api/getConsolidationScoreInadimplencia.ts';
import LoadingChart from '@/features/dashboard/components/LoadingChart';

const ScoreInadimplencia = ({ year: yearProp }: { year?: number }) => {
  const { data, isFetched, isFetching } = useConsolidationScoreInadimplencia(yearProp);
  const [year, setYear] = useState<number | null>(null);

  useEffect(() => {
    if (isFetched) {
      const currentYear = new Date().getFullYear();
      const listYears = Object
        .keys(groupBy(data, 'ano'))
        .map((item) => Number(item))
        .sort((a, b) => b - a);
      if (listYears.length) {
        setYear(year === null ? currentYear : year);
      }
    }
  }, [isFetched, data, year]);

  const onApplyFilter = (selectedYear) => {
    setYear(selectedYear);
  };

  const selectedData = data?.length ? data?.find((item) => Number(item.ano) === year) : null;

  return (
    <>
      <LoadingChart loading={isFetching} />

      {data?.length && selectedData && (
        <ScoreInadimplenciaChart data={selectedData} />
      )}

      {isFetched && (
        <Box marginTop={'10px'}>
          <PeriodFilter
            year={year}
            years={Object.keys(groupBy(data, 'ano')).map(Number)}
            onApplyFilter={onApplyFilter} />
        </Box>
      )}
    </>
  );
};

export default ScoreInadimplencia;
